module.exports = __webpack_public_path__ + "img/fisherman.dc9a85b0.jpg";